import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DrawerService {
  private openDrawer$ = new Subject<void>();
  private closeDrawer$ = new Subject<void>();

  openDrawerChanged$ = this.openDrawer$.asObservable();
  closeDrawerChanged$ = this.closeDrawer$.asObservable();

  open() {
    this.openDrawer$.next();
  }

  close() {
    this.closeDrawer$.next();
  }
}